module.exports = __webpack_public_path__ + "img/ddfe87c468c24c21868c1d5477e62d87-1440.c1b735a7.jpg";